import React, { Component } from 'react';
import { Image, Col, Row, Container} from 'react-bootstrap';
import Arrow from '../../../img/Arrow.svg'
import Resorte from '../../../img/NewPNG/Espiral.png'
import Rocket from '../../../img/NewPNG/Cohete.png'
import Billete from '../../../img/newIcons/Pagos.svg'
import BTCIcono from '../../../img/newIcons/CriptoPagos.svg'
import Comercio from '../../../img/newIcons/Comercio.svg'
import Usuarios from '../../../img/newIcons/Cuentas.svg'
import Escudo from '../../../img/newIcons/Seguridad.svg'
import Ubicacion from '../../../img/newIcons/ubicacion.svg'
import Translate from '../../../../../translate'
import './index.css'

class Unete extends Component {
  constructor(props){
    super(props);
    this.state = {

    }
  }

  render() {
    return (
      <div className='buscas-background section-container' id='empieza'>
        <div className='buscas-outter'>
          <Container>
            <Row>
              <Col md={12} className={'sectionColumnsTitles padding-mobile'} >
                <div>
                  <p className='title-regular'>{Translate[this.props.lan].landing3.seccion4.titulo}</p>
                  <p className='subtitle-regular'>
                    {Translate[this.props.lan].landing3.seccion4.subtitulo}<br/>
                    {Translate[this.props.lan].landing3.seccion4.subtitulo1}
                  </p>
                  <p className='subtitle-regular-mobile'>
                    {Translate[this.props.lan].landing3.seccion4.subtitulo} {Translate[this.props.lan].landing3.seccion4.subtitulo1}
                  </p>
                  <p 
                    className='link-associate' 
                    style={{textAlign:'center'}} 
                    onClick={()=>window.open(window.location.origin + '/register','_blank')}
                  >
                    {Translate[this.props.lan].landing3.hipervinculo3} <Image src={Arrow} style={{marginLeft: '5px'}} width="25px"/>
                  </p>
                </div>
              </Col>
              <Col>
                <div className='buscas-conatiner'>
                  <Row style={{margin:0}}>
                    <Col sm={12} md={4} lg={4}>
                      <Image src={Billete} className="ecommerceIcon" />                 
                      <p className='buscas-title'>{Translate[this.props.lan].landing3.seccion4.facilita}</p>
                      <p className='buscas-text'>{Translate[this.props.lan].landing3.seccion4.facilitaDesc}</p>
                    </Col>
                    <div md={12} className="lineaBlanca"/>
                    <Col sm={12} md={4} lg={4}>
                      <Image src={BTCIcono} className="ecommerceIcon" />                      
                      <p className='buscas-title'>{Translate[this.props.lan].landing3.seccion4.recepcion}</p>
                      <p className='buscas-text'>{Translate[this.props.lan].landing3.seccion4.recepcionDesc}</p>
                    </Col>
                    <div md={12} className="lineaBlanca"/>
                    <Col sm={12} md={4} lg={4}>
                      <Image src={Comercio} className="ecommerceIcon" />                      
                      <p className='buscas-title'>{Translate[this.props.lan].landing3.seccion4.comisiones}</p>
                      <p className='buscas-text'>{Translate[this.props.lan].landing3.seccion4.comisionesDesc}</p>
                    </Col>
                    <div md={12} style={{border:'1px solid #DDE0FC', width:'97%', marginBottom:10, marginTop:10, marginLeft:15}}/>
                    <Col sm={12} md={4} lg={4}>
                      <Image src={Usuarios} className="ecommerceIcon" />                      
                      <p className='buscas-title'>{Translate[this.props.lan].landing3.seccion4.tipoCuentas}</p>
                      <p className='buscas-text'>{Translate[this.props.lan].landing3.seccion4.tipoCuentasDesc}</p>
                    </Col>
                    <div md={12} className="lineaBlanca"/>
                    <Col sm={12} md={4} lg={4}>
                      <Image src={Escudo} className="ecommerceIcon" />                      
                      <p className='buscas-title'>{Translate[this.props.lan].landing3.seccion4.estandares}</p>
                      <p className='buscas-text'>{Translate[this.props.lan].landing3.seccion4.estandaresDesc}</p>
                    </Col>
                    <div md={12} className="lineaBlanca"/>
                    <Col sm={12} md={4} lg={4}>
                      <Image src={Ubicacion} className="ecommerceIcon" />                      
                      <p className='buscas-title'>{Translate[this.props.lan].landing3.seccion4.empresa}</p>
                      <p className='buscas-text'>{Translate[this.props.lan].landing3.seccion4.empresaDesc}</p>
                    </Col>
                  </Row>
                  <Image src={Rocket} className='floating-rocket'/>
                  <Image src={Resorte} className='floating-resorte'/>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

export default Unete
